import {Formik} from 'formik';
import {FormComponent} from './FormComponent';
import {RecordSchema} from './RecordSchema';
import {FormWithButtons} from '@flexinet/ui-components';
import {ApplicationRecordFormProps} from '../types';
import {buildInitialValues, FormValues} from './buildInitialValues';
import {stage} from "../../../config/stage";


export const RecordForm = (
    {
        record,
        handleSubmit,
        handleCancel
    }: ApplicationRecordFormProps) => {

    // FNP-1498: the payload is the form values, unchanged. Creating a record
    // creates a record and nothing else.
    const onSubmit = (values: FormValues) => {
        handleSubmit(values);
    };

    const initialValues = buildInitialValues(record);

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={handleCancel} debug={false && stage === 'ide'} {...rest}  >
                    <FormComponent/>
                </FormWithButtons>)}
        </Formik>
    );
};
